<!--
 * @Description: 历史请求日志弹窗（清分/分账/提现共用）
-->
<template>
  <ykc-operation-dialog
    title="历史请求日志"
    customer-width="900px"
    confirm-btn-txt="关 闭"
    :show-cancel-button="false"
    :show="show"
    @update:show="value => $emit('update:show', value)">
    <div slot="content" class="clearing-log-dialog">
      <div class="log-sn">
        <span class="log-sn-label">编码：</span>
        <span class="log-sn-value">{{ clientSn }}</span>
      </div>
      <ykc-table :data="logList" :columns="logColumns"></ykc-table>
    </div>
  </ykc-operation-dialog>
</template>

<script>
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import { clearingLogRecord } from '@/service/apis';

  export default {
    name: 'ClearingLogDialog',
    components: {
      YkcOperationDialog,
    },
    props: {
      // 是否展示弹窗
      show: Boolean,
      // 业务类型 1余额清分 2分账 3提现
      type: Number,
      // 业务编号（清分编码/分账编码/提现记录编码）
      clientSn: String,
    },
    data() {
      return {
        logList: [],
        logColumns: [
          { label: '请求时间', prop: 'requestTime', minWidth: '170px' },
          {
            label: '请求人',
            prop: 'requestPersionName',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.requesterType === 0 ? '系统' : row.requestPersionName}</span>;
              },
            },
          },
          { label: '请求交易金额（元）', prop: 'amount', minWidth: '140px' },
          {
            label: '请求返回状态',
            prop: 'requestReturn',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <span class="log-return-status">
                    {row.requestReturn === 1 ? '交易成功' : '交易失败'}
                  </span>
                );
              },
            },
          },
          { label: '描述', prop: 'failReason', minWidth: '180px' },
        ],
      };
    },
    watch: {
      show(value) {
        if (value) {
          this.fetchLogs();
        }
      },
    },
    methods: {
      /** 拉取历史请求日志 */
      fetchLogs() {
        this.logList = [];
        clearingLogRecord
          .queryList({ type: this.type, clientSn: this.clientSn })
          .then(response => {
            this.logList = response || [];
          })
          .catch(() => {
            this.logList = [];
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .clearing-log-dialog {
    padding: 10px 0;

    .log-sn {
      margin-bottom: 12px;
      font-size: 14px;

      .log-sn-label {
        color: #606266;
      }

      .log-sn-value {
        color: #303133;
        font-weight: 500;
      }
    }

    .log-return-status {
      color: #303133;
    }
  }
</style>
